import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import z from "zod/v4";

export const selectReturnItems = {
  name: "selectReturnItems" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnItemIds: z.string().array(),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
